export default function numberWithSpaces(value, words,onlyWord) {
  value = Math.abs(value)
  let cases = [2, 0, 1, 1, 1, 2]
  if (onlyWord) {
    return words[ (value%100>4 && value%100<20)? 2 : cases[(value%10<5)?value%10:5] ]
  } else {
    return value.toString() + ' ' + words[ (value%100>4 && value%100<20)? 2 : cases[(value%10<5)?value%10:5] ]
  }
  
}

/**
  * Существительные: [один, два, несколько]. Например [модель, модели, моделей]
  * Глаголы, прилагательные: [она, оно, они]. Например: [всплыла, всплыло, всплыли], [красивая, красивое, красивые]
  * onlyWord передаем true если надо чтобы вернулось только слово, если передается false, то вернется число + пробел + слово
  */